import postscribe from 'postscribe';
import AbstractDriver from './abstract-driver';

/* eslint no-undef: "error" */
class CallRailSwap extends AbstractDriver
{
    constructor()
    {
        super();

        this.firstLoad = false;
    }

    init(config)
    {
        if (!this.firstLoad && this._hasUtmCampaign())
        {
            this._loadScript(config);
        }
    }

    async pageView()
    {
        return true;
    }

    async lead()
    {
        return true;
    }

    _exists()
    {
        return true;
    }

    _hasUtmCampaign()
    {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.has('utm_campaign');
    }

    _loadScript()
    {
        postscribe(document.querySelector('head'), `
            <script defer type="text/javascript" src="https://cdn.callrail.com/companies/977764365/47f6815d19496265ab82/12/swap.js"></script>
        `, {
            done: () =>
            {
                this.firstLoad = true;
                this.init();
            },

        });

        return true;
    }
}

export default CallRailSwap;
